import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { TraderRequest, TraderResponse } from '../models/types'
import { traderQueryKeys } from '../keys'

const baseUrl = `${process.env.REACT_APP_API_URL}/v3/trader`

export function useUpdateTraderMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, request }: { id: number; request: TraderRequest }) => {
      const { data } = await axios.put<TraderResponse>(`${baseUrl}/${id}`, request)

      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: traderQueryKeys.all }),
  })
}

export async function deleteTrader(id: number) {
  await axios.delete(`${baseUrl}/${id}`)
}
